export const chartSelectList = [
  { id: 'spend', name: '费用' },
  { id: 'conversions', name: '转化次数' },
  { id: 'costPerConversion', name: '每次转化费用' },
  { id: 'allConversions', name: '所有转化次数' },
  { id: 'costPerAllConversions', name: '费用/所有转化次数' },
];

export const AudienceFeature = [
  { id: 'age', name: '年龄' },
  { id: 'gender', name: '性别' },
  { id: 'income', name: '家庭收入' },
  { id: 'parental', name: '育儿状况' },
];
export const tableBaseData = [
  {
    key: 'spend',
    label: '费用',
    type: 'money',
    sortable: true,
  },
  {
    key: 'conversions',
    label: '转化次数',
    sortable: true,
  },
  {
    key: 'costPerConversion',
    label: '每次转化费用',
    type: 'money',
  },
  {
    key: 'allConversions',
    label: '所有转化次数',
  },
  {
    key: 'costPerAllConversions',
    label: '费用/所有转化次数',
    type: 'money',
  },

  {
    key: 'impressions',
    label: '展示次数',
  },
  {
    key: 'cpc',
    label: '平均每次点击费用',
    type: 'money',
  },
  {
    key: 'clicks',
    label: '点击次数',
  },

  {
    key: 'cpm',
    label: '千次展现费用',
    type: 'money',
  },
  {
    key: 'conversionRate',
    label: '转化率',
    type: 'percent',
  },
];

export function getTableData(data) {
  const list = [];

  // 处理详细报告数据
  if (data?.detailReports?.length) {
    const detailReportsList = data.detailReports.map((report) => ({
      ...report.metrics,
      status: report.displayStatus,
      displayStatus: report.displayStatus,
      reasonStatusList: report.reasonStatusList,
      name: report.name,
      type: report.type,
      dataType: 'detail',
    }));
    list.push(...detailReportsList);
  }

  // 添加汇总数据
  if (data?.summaryMetrics) {
    list.push({ ...data.summaryMetrics, dataType: 'summary', name: data.summaryMetrics.columnName });
  }

  if (data?.estimateDiffMetrics) {
    list.push({ ...data.estimateDiffMetrics, dataType: 'estimate', name: data.estimateDiffMetrics.columnName });
  }

  if (data?.adGroupMetrics) {
    list.push({ ...data.adGroupMetrics, dataType: 'adGroup', name: data.adGroupMetrics.columnName });
  }

  return list;
}

export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
